/* TWRD 2026-10-15: Instafeed popup enhancement (progressive).
   Restyles the caption by brand tier, adds a "Shop the look" card and a
   "View on Instagram" link. Works only inside .instafeed-lightbox. Uses
   textContent only, never innerHTML from the caption. Does nothing if the
   app DOM is missing. App JS and the consent gate are untouched. */
(function () {
  'use strict';
  if (window.__twrdIgPopup) return;
  window.__twrdIgPopup = true;

  var IG_URL = 'https://www.instagram.com/thwrdcom/';
  var FALLBACK_URL = '/collections/every-piece';
  var LABEL_RE = /^(thwrd\.com\b|the word$|music:|imagery:|photo:|https?:\/\/|www\.)/i;
  var URL_ONLY_RE = /^[\w.-]+\.(com|org|net|dk|io)(\/\S*)?$/i;
  var REF_RE = /^(.*\S)\s*([-–—])\s*((?:[1-3]\s?)?[A-Z][A-Za-z]+(?:\s(?:of\s)?[A-Z][A-Za-z]+)?\s\d{1,3}:\d{1,3}(?:[-–]\d{1,3})?)\s*$/;
  var EDITION_RE = /\s*[·•|-]\s*(black\s*&\s*white|white|black|smoky\s*black|vintage(?:\s*&\s*sunfaded)?)\s*$/i;

  var products = null;

  function loadProducts() {
    if (products) return products;
    products = [];
    var el = document.getElementById('twrd-insta-products');
    if (!el) return products;
    try {
      var data = JSON.parse(el.textContent || '[]');
      if (Array.isArray(data)) products = data.filter(function (p) { return p && p.title && p.url; });
    } catch (e) {
      products = [];
    }
    return products;
  }

  function norm(s) {
    return ' ' + String(s || '')
      .toUpperCase()
      .replace(/[‘’']/g, '')
      .replace(/&/g, ' AND ')
      .replace(/[^A-Z0-9]+/g, ' ')
      .trim() + ' ';
  }

  /* "LIGHT OF THE WORLD · BLACK & WHITE" -> base "LIGHT OF THE WORLD", edition "Black & White". */
  function splitTitle(title) {
    var base = String(title).replace(/\s*\([^)]*\)\s*$/, '');
    var editions = [];
    var prev;
    do {
      prev = base;
      base = base.replace(EDITION_RE, function (_, ed) { editions.unshift(ed); return ''; });
    } while (base !== prev);
    return { base: base.trim(), edition: editions.join(' ') };
  }

  function keysFor(title) {
    var base = splitTitle(title).base;
    var keys = [{ key: norm(base), bonus: base === title ? 1 : 0 }];
    String(base).split(/\s*[·•]\s*/).forEach(function (seg) {
      if (seg.trim().split(/\s+/).length >= 3) keys.push({ key: norm(seg), bonus: -2 });
    });
    return keys;
  }

  /* Ranking: (1) a standalone headline or caps line that equals a product
     name wins; (2) otherwise the longest whole-word match in headline, caps,
     body and poem lines. Verse quotes (lines with a Bible reference) never count. */
  function matchProduct(strongLines, text) {
    var hay = norm(text);
    var strong = strongLines.map(norm);
    var best = null;
    var bestScore = 0;
    loadProducts().forEach(function (p) {
      keysFor(p.title).forEach(function (k) {
        if (k.key.trim().length < 6) return;
        var score = 0;
        if (strong.indexOf(k.key) !== -1) score = 100000 + k.key.length * 2 + k.bonus;
        else if (hay.indexOf(k.key) !== -1) score = k.key.length * 2 + k.bonus;
        if (score > bestScore) { bestScore = score; best = p; }
      });
    });
    return best;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function classify(line, isFirst) {
    var t = line.trim();
    if (isFirst) return { type: 'head' };
    if (LABEL_RE.test(t) || URL_ONLY_RE.test(t)) return { type: 'label' };
    var m = t.match(REF_RE);
    if (m) return { type: 'verse', quote: m[1], ref: m[2] + ' ' + m[3] };
    var letters = t.replace(/[^A-Za-z]/g, '');
    if (letters.length >= 4 && letters === letters.toUpperCase() && t.length <= 60) return { type: 'caps' };
    if (t.length <= 60) return { type: 'poem' };
    return { type: 'body' };
  }

  /* Credits block: "Key: value" lines become label/value rows, a bare URL
     after a row becomes a link under that value. The brand name and the
     plain shop domain are dropped, the header already says who posted. */
  var KV_RE = /^([A-Za-z][A-Za-z ]{1,14}):\s*(.+)$/;
  var DROP_RE = /^(the word|thwrd\.com\/?)$/i;

  function metaLink(url) {
    if (url === '/pages/music') {
      var m = el('a', 'twrd-ig-meta__link', 'Hear the album');
      m.setAttribute('href', '/pages/music');
      return m;
    }
    var href = /^https?:\/\//i.test(url) ? url : 'https://' + url.replace(/^\/+/, '');
    var a = el('a', 'twrd-ig-meta__link', url.replace(/^https?:\/\//i, '').replace(/\/$/, ''));
    /* thwrd.com must end the host (end, /, ? or #), so thwrd.com.evil.dk is external. */
    var internal = /^(https?:\/\/)?(www\.)?thwrd\.com(?=$|[\/?#])/i.test(url);
    var path = internal ? href.replace(/^https?:\/\/(www\.)?thwrd\.com(?=$|[\/?#])/i, '') : '';
    if (internal && path.charAt(0) !== '/') path = '/' + path;
    /* href is always http(s) (see above) or a relative path on our own site. */
    a.setAttribute('href', internal ? path : href);
    if (!internal) { a.setAttribute('target', '_blank'); a.setAttribute('rel', 'noopener'); }
    return a;
  }

  function buildMeta(lines) {
    var rows = [];
    lines.forEach(function (l) {
      var t = l.trim();
      if (!t || DROP_RE.test(t)) return;
      var kv = t.match(KV_RE);
      if (kv) { rows.push({ key: kv[1].trim(), value: kv[2].trim(), links: [] }); return; }
      if (LABEL_RE.test(t) || URL_ONLY_RE.test(t)) {
        if (rows.length) rows[rows.length - 1].links.push(t);
        else rows.push({ key: '', value: '', links: [t] });
        return;
      }
      rows.push({ key: '', value: t, links: [] });
    });
    /* Owner 2026-10-15: no Imagery credit in the popup; Music links to /pages/music. */
    rows = rows.filter(function (r) { return !/^imagery$/i.test(r.key); });
    rows.forEach(function (r) { if (/^music$/i.test(r.key)) r.links = ['/pages/music']; });
    if (!rows.length) return null;
    var dl = el('dl', 'twrd-ig-meta');
    rows.forEach(function (r) {
      var row = el('div', 'twrd-ig-meta__row');
      row.appendChild(el('dt', 'twrd-ig-meta__key', r.key));
      var dd = el('dd', 'twrd-ig-meta__val');
      if (r.value) dd.appendChild(document.createTextNode(r.value));
      r.links.forEach(function (u) { dd.appendChild(metaLink(u)); });
      row.appendChild(dd);
      dl.appendChild(row);
    });
    return dl;
  }

  function buildCaption(text) {
    var wrap = el('div', 'twrd-ig-cap');
    var lines = String(text).replace(/\r\n?/g, '\n').split('\n');
    var seenFirst = false;
    var labels = [];
    var group = null;
    var groupType = null;
    var bodyText = [];
    var strongLines = [];

    function closeGroup() { group = null; groupType = null; }

    lines.forEach(function (raw) {
      var line = raw.replace(/\s+$/, '');
      if (!line.trim()) { closeGroup(); return; }
      var c = classify(line, !seenFirst);
      seenFirst = true;
      if (c.type === 'label') { labels.push(line.trim()); closeGroup(); return; }
      if (c.type !== 'verse') bodyText.push(line);
      if (c.type === 'head' || c.type === 'caps') strongLines.push(line.trim());
      if (c.type === 'head') { wrap.appendChild(el('p', 'twrd-ig-cap__head', line.trim())); closeGroup(); return; }
      if (c.type === 'verse') {
        var v = el('p', 'twrd-ig-cap__verse');
        v.appendChild(el('span', 'twrd-ig-cap__quote', c.quote));
        v.appendChild(el('span', 'twrd-ig-cap__ref', c.ref));
        wrap.appendChild(v);
        closeGroup();
        return;
      }
      if (c.type === 'caps') { wrap.appendChild(el('p', 'twrd-ig-cap__caps', line.trim())); closeGroup(); return; }
      var cls = c.type === 'poem' ? 'twrd-ig-cap__poem' : 'twrd-ig-cap__body';
      if (!group || groupType !== c.type) {
        group = el('p', cls);
        groupType = c.type;
        wrap.appendChild(group);
      } else {
        group.appendChild(document.createElement('br'));
      }
      group.appendChild(document.createTextNode(line.trim()));
    });

    var meta = buildMeta(labels);
    if (meta) wrap.appendChild(meta);
    return { node: wrap, matchText: bodyText.join('\n'), strongLines: strongLines };
  }

  function buildCard(product) {
    var card = el('div', 'twrd-ig-shop');
    var href = product ? product.url : FALLBACK_URL;
    if (product && product.image) {
      var thumb = el('a', 'twrd-ig-shop__thumb');
      thumb.href = href;
      thumb.setAttribute('tabindex', '-1');
      thumb.setAttribute('aria-hidden', 'true');
      var img = el('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 64;
      img.height = 64;
      thumb.appendChild(img);
      card.appendChild(thumb);
    }
    var info = el('div', 'twrd-ig-shop__info');
    var parts = product ? splitTitle(product.title) : null;
    info.appendChild(el('p', 'twrd-ig-shop__eyebrow', product ? 'Shop the look' : 'The Word'));
    info.appendChild(el('p', 'twrd-ig-shop__name', product ? (parts.base || product.title) : 'Every piece'));
    if (product && (product.price || parts.edition)) {
      var price = el('p', 'twrd-ig-shop__price', product.price || '');
      if (parts.edition) price.appendChild(el('span', 'twrd-ig-shop__edition', (product.price ? ' \u00b7 ' : '') + parts.edition));
      info.appendChild(price);
    }
    card.appendChild(info);
    var btn = el('a', 'twrd-ig-shop__btn', product ? 'Shop' : 'Shop the collection');
    btn.href = href;
    if (product) btn.setAttribute('aria-label', 'Shop ' + product.title);
    card.appendChild(btn);
    return card;
  }

  function enhance(box) {
    var caption = box.querySelector('.instafeed-caption');
    var desc = box.querySelector('.description');
    if (!caption || !desc) return;
    if (caption.querySelector('.twrd-ig-cap')) return;
    var text = caption.textContent;
    if (!text || !text.trim()) return;

    var built = buildCaption(text);
    caption.textContent = '';
    caption.appendChild(built.node);
    caption.classList.add('twrd-ig-on');
    box.classList.add('twrd-ig-enhanced');

    var old = desc.querySelector('.twrd-ig-shop');
    if (old) old.parentNode.removeChild(old);
    var card = buildCard(matchProduct(built.strongLines, built.matchText));
    var date = desc.querySelector('.post-date');
    if (date && date.parentNode === desc) desc.insertBefore(card, date);
    else desc.appendChild(card);

    if (date && !date.querySelector('.twrd-ig-view')) {
      var a = el('a', 'twrd-ig-view', 'View on Instagram');
      a.href = IG_URL;
      a.target = '_blank';
      a.rel = 'noopener';
      date.appendChild(a);
    }
  }

  function scan(root) {
    var boxes = (root || document).querySelectorAll('.instafeed-lightbox .lightbox-instagram');
    for (var i = 0; i < boxes.length; i++) {
      try { enhance(boxes[i]); } catch (e) { /* leave the app's own popup as is */ }
    }
  }

  var queued = false;
  function queueScan(root) {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(root); });
  }

  function watchWrapper(wrapper) {
    if (wrapper.__twrdIgWatched) return;
    wrapper.__twrdIgWatched = true;
    scan(wrapper);
    new MutationObserver(function () { queueScan(wrapper); })
      .observe(wrapper, { childList: true, subtree: true });
  }

  function watchAll() {
    var ws = document.querySelectorAll('.instafeed-modals-wrapper');
    for (var i = 0; i < ws.length; i++) watchWrapper(ws[i]);
  }

  function init() {
    if (!window.MutationObserver || !document.body) return;
    watchAll();
    /* The app appends its modal wrapper to <body>; childList only keeps this cheap. */
    new MutationObserver(watchAll).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
